'use client'

import Modal from '@/donationPages/_dependencies/components/Modal'
import TextLink from '@/components/TextLink'
import styles from './Terms.module.css'
import { Button } from '@betterplace/design-system/client'
import { PaymentMethods } from '@betterplace/api-graphql-types/enums'
import { postMessageScrollTop } from '@/helpers/utils'
import { useCallback, useState } from 'react'
import { useDonationFormConfig, useDonationFormValues } from '@/donationPages/_dependencies/helpers'
import { useTranslations } from 'next-intl'

const TermsLink = () => {
  const t = useTranslations('nextjs.donate.terms')
  return (
    <TextLink target="_blank" largerClickArea href={t('terms_url')} rel="noopener noreferrer">
      {t('terms_label')}
    </TextLink>
  )
}

const PrivacyLink = () => {
  const t = useTranslations('nextjs.donate.terms')
  return (
    <TextLink target="_blank" largerClickArea href={t('privacy_url')} rel="noopener noreferrer">
      {t('privacy_label')}
    </TextLink>
  )
}

function BetterplaceInfo() {
  const t = useTranslations('nextjs')
  const { channel } = useDonationFormConfig()
  const [showModal, setShowModal] = useState(false)
  const hideModal = useCallback(() => {
    setShowModal(false)
  }, [])
  const openModal = useCallback(() => {
    setShowModal(true)
  }, [])
  const channelPart = channel === 'iframe' ? channel : 'default'

  return (
    <>
      {' '}
      <span>{t(`donate.terms.${channelPart}_recipient_info`)}</span>{' '}
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
      <TextLink href="javascript:void(0)" onClick={openModal}>
        {t('donate.terms.default_recipient_name')}
      </TextLink>{' '}
      <span>(betterplace.org gGmbH)</span>
      <Modal
        onClose={hideModal}
        id="betterplace-info-modal"
        onOpen={postMessageScrollTop}
        isOpen={showModal}
        title={t('donate.terms.recipient_info_modal_headline')}
        customActions={
          <Button kind="primary" size="small" onClick={hideModal} type="button" className={styles.closeModalButton}>
            {t('donate.codonation_selection.why_modal.close_button')}
          </Button>
        }
        closeText={t('core.close')}
      >
        <span>{t('donate.terms.recipient_info_modal_text')}</span>
        <br />
        <TextLink href={t('donate.terms.gut_org_help_url')} target="_blank" rel="noopener noreferrer">
          {t('donate.terms.recipient_info_read_more_label')}
        </TextLink>
      </Modal>
    </>
  )
}

function SEPAMandateLink() {
  const [paymentMethod] = useDonationFormValues(['payment_method'])

  const [showModal, setShowModal] = useState(false)
  const hideModal = useCallback(() => {
    setShowModal(false)
  }, [])
  const openModal = useCallback(() => {
    setShowModal(true)
  }, [])

  const t = useTranslations('nextjs')
  if (paymentMethod !== PaymentMethods.StripeSepaDebit) return null

  return (
    <>
      {' '}
      <span>{t('donate.terms.sepa_prefix')}</span>{' '}
      <TextLink href="javascript:void(0)" onClick={openModal}>
        {/* TODO: fix href when moving modal to route based modal */}
        {t('donate.terms.sepa_mandate_label')}
      </TextLink>
      <Modal
        onClose={hideModal}
        onOpen={postMessageScrollTop}
        isOpen={showModal}
        title={t('donate.terms.sepa_mandate_label')}
        customActions={
          <Button kind="primary" size="small" onClick={hideModal} type="button" className={styles.closeModalButton}>
            {t('donate.codonation_selection.why_modal.close_button')}
          </Button>
        }
        closeText={t('core.close')}
      >
        {t('donate.terms.sepa_mandate_stripe_disclaimer')}
      </Modal>
    </>
  )
}

export default function Terms() {
  const t = useTranslations('nextjs.donate.terms')

  return (
    <div className={styles.termsOfUseContainer}>
      <span>{t('terms_link_prefix')}</span>
      <TermsLink />
      <span>{t('privacy_link_prefix')}</span>
      <PrivacyLink />
      <BetterplaceInfo />
      <SEPAMandateLink />
      <span>{t('terms_suffix')}</span>
    </div>
  )
}
